import * as tslib_1 from "tslib";
import { getStore } from '../store/store';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { CategoryIcon } from 'owa-categories';
import { getCategoryColorsForCategory, getMasterCategoryList } from 'owa-categories';
import { PersonaPill } from 'owa-search';
import { SuggestionKind } from 'owa-search-service';
import * as React from 'react';
var styles = require('./SearchBoxPillWell.scss');
var SearchBoxPillWell = /** @class */ (function (_super) {
    tslib_1.__extends(SearchBoxPillWell, _super);
    function SearchBoxPillWell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchBoxPillWell.prototype.renderPersonaPill = function (pillId, persona) {
        var _this = this;
        return (React.createElement("div", { key: pillId, className: styles.personaPillContainer },
            React.createElement(PersonaPill, { name: persona.DisplayName, emailAddress: persona.EmailAddresses[0], personaPillId: pillId, onRemoveClick: this.props.onRemovePill, personaType: 'User' }),
            React.createElement(IconButton, { className: styles.removePersonaIcon, iconProps: {
                    iconName: "Cancel" /* Cancel */,
                    styles: {
                        root: styles.cancelIcon,
                    },
                }, onClick: function () { return _this.props.onRemovePill(pillId); } })));
    };
    SearchBoxPillWell.prototype.renderCategoryPilll = function (pillId, categorySuggestion) {
        var _this = this;
        var categoryName = categorySuggestion.Name;
        var categoryColor = getCategoryColorsForCategory(categoryName, getMasterCategoryList());
        var categoryPillStyle = {
            backgroundColor: categoryColor.primaryColor,
            borderColor: categoryColor.secondaryColor,
            color: categoryColor.textColor,
        };
        var iconStyles = { color: categoryColor.iconColor };
        var iconStylesOnHover = { backgroundColor: categoryColor.secondaryColor };
        return (React.createElement("div", { key: pillId, className: styles.pillContainerCommon, style: categoryPillStyle },
            React.createElement(CategoryIcon, { categoryName: categoryName, iconClassName: styles.categoryIcon }),
            React.createElement("div", { className: styles.categoryPillNameText, title: categoryName }, categoryName),
            React.createElement(Icon, { styles: {
                    root: [
                        iconStyles,
                        styles.removeIconCommon,
                        styles.cancelIcon,
                        {
                            selectors: {
                                '&:hover': iconStylesOnHover,
                            },
                        },
                    ],
                }, iconName: "Cancel" /* Cancel */, onClick: function () { return _this.props.onRemovePill(pillId); } })));
    };
    SearchBoxPillWell.prototype.renderPills = function () {
        var searchStore = getStore();
        var pills = [];
        var length = searchStore.suggestionPillIds.length;
        for (var i = 0; i < length; i++) {
            var pillId = searchStore.suggestionPillIds[i];
            var suggestion = searchStore.suggestionPills.get(pillId);
            if (suggestion.kind == SuggestionKind.People) {
                pills.push(this.renderPersonaPill(pillId, suggestion));
            }
            else if (suggestion.kind == SuggestionKind.Category) {
                pills.push(this.renderCategoryPilll(pillId, suggestion));
            }
        }
        return pills;
    };
    SearchBoxPillWell.prototype.render = function () {
        return React.createElement("div", { className: styles.searchBoxPillWell }, this.renderPills());
    };
    SearchBoxPillWell = tslib_1.__decorate([
        observer
    ], SearchBoxPillWell);
    return SearchBoxPillWell;
}(React.Component));
export default SearchBoxPillWell;
//# sourceMappingURL=SearchBoxPillWell.js.map